module.exports = __webpack_public_path__ + "static/media/filter.8d5eaf00.jpg";